import { ColumnDef } from "@tanstack/react-table";
import { DateTimeColumn } from "@/components/tableColumns/DateTimeColumn";
import { DurationColumn } from "@/components/tableColumns/DurationColumn";
import { LinkColumn } from "@/components/tableColumns/LinkColumn";
import { StructureNameCell } from "@/components/tableColumns/StructureNameCell";
import { BlockageStatusBadge } from "@/components/badges/BlockageStatusBadge";
import { NumberColumn } from "@/components/tableColumns/NumberColumn";
import { ExpandColumn } from "@/components/tableColumns/ExpandColumn";

export const Columns: ColumnDef<Dryp.Blockage>[] = [
	ExpandColumn<Dryp.Blockage>(),
	{
		id: "structureId",
		accessorKey: "structureId",
		header: "Structure id",
	},
	LinkColumn({
		accessorKey: "structureName",
		id: "structureName",
		header: "Name",
		className: "font-medium tracking-tight",
		linkText: row => <StructureNameCell name={row.structureName} isActive={row.isActive} />,
		link: row => ({
			to: "Dashboard.Structures.Structure",
			params: { id: row.structureId },
			query: {},
		}),
		tooltipText: row => `Go to ${row.structureName}`,
	}),
	{
		accessorKey: "status",
		id: "status",
		header: "Status",
		cell: ({ row }) => {
			const status = row.original.status;
			return (
				<div>
					<BlockageStatusBadge status={status} />
				</div>
			);
		},
	},
	DateTimeColumn({
		accessorKey: "estimatedNextBlockageTime",
		id: "estimatedNextBlockageTime",
		header: "Est. Next Blockage",
		format: "dd LLL yyyy, HH:mm",
		align: "left",
		datetimeClassName: "text-sm",
	}),
	DurationColumn({
		id: "estimatedNextBlockageInterval",
		accessorKey: "estimatedNextBlockageInterval",
		header: "Est. Blockage Interval",
		align: "left",
		durationClassName: "text-sm",
	}),
	DateTimeColumn({
		accessorKey: "lastBlockageTime",
		id: "lastBlockageTime",
		header: "Last Blockage",
		format: "dd LLL yyyy, HH:mm",
		align: "left",
		datetimeClassName: "text-sm",
	}),
	NumberColumn({
		accessorKey: "accumulatedRain",
		id: "accumulatedRain",
		header: "Last 24h rain",
		d3Format: ".1f",
		meta: {
			unit: "mm",
		},
	}),
	NumberColumn({
		accessorKey: "dataQuality",
		id: "dataQuality",
		header: "Data Coverage",
		meta: {
			unit: "%",
		},
	}),
	DateTimeColumn({
		accessorKey: "updatedAt",
		id: "updatedAt",
		header: "Checked at",
		format: "dd LLL yyyy, HH:mm",
		align: "left",
		datetimeClassName: "text-sm",
	}),
];
